import type { Point } from './types';

export type Viewport = { width: number; height: number };

export type Camera2D = {
    offsetX: number;
    offsetY: number;
    zoom: number;
    worldToScreen: (p: Point) => Point;
    screenToWorld: (p: Point) => Point;
    zoomAt: (screenPt: Point, delta: number) => void;
};

export function createCamera2D(getViewport: () => Viewport): Camera2D {
    return {
        offsetX: 0,
        offsetY: 0,
        zoom: 1,
        worldToScreen(p: Point): Point {
            const { width, height } = getViewport();
            return {
                x: (p.x + this.offsetX) * this.zoom + width / 2,
                y: (p.y + this.offsetY) * this.zoom + height / 2,
            };
        },
        screenToWorld(p: Point): Point {
            const { width, height } = getViewport();
            return {
                x: (p.x - width / 2) / this.zoom - this.offsetX,
                y: (p.y - height / 2) / this.zoom - this.offsetY,
            };
        },
        zoomAt(screenPt: Point, delta: number) {
            const prev = this.screenToWorld(screenPt);
            this.zoom = Math.max(0.3, Math.min(3.0, this.zoom * delta));
            const next = this.screenToWorld(screenPt);
            this.offsetX += next.x - prev.x;
            this.offsetY += next.y - prev.y;
        },
    };
}
